import { useNavigate } from 'react-router-dom'

import { ButtonComponent } from '../../components/Button'
import { CategoryListComponent } from '../../components/CategoryList'
import { LayoutPage } from '../../components/LayoutPage'
import { PageTitleComponent } from '../../components/PageTitleComponent'
import { SpinnerComponent } from '../../components/Spinner'

import { useControlSearchCategories } from '../../hooks/useControlSearchCategories'
import { useSimpleState } from '../../hooks/useSimpleState'
import { useView } from '../../hooks/useView'

import './index.css'

const ManageCategoriesPage = () => {
    const navigate = useNavigate()

    const { _state } = useSimpleState({
        fetching: false
    })

    const {_view: _viewMain} = useView({
        initialView: 'main',
        views: {
            loading: renderLoading,
            main: renderMain
        }
    })

    const {_control, _results} = useControlSearchCategories({
        beforeFetch: () => _state.set('fetching', true),
        afterFetch: () => _state.set('fetching', false)
    })

    const handleGoToEdit = (item) => {
        navigate(`/edit-category/${item.id}`)
    }

    const handleDelete = (item) => {
        if (window.confirm(`Delete ${item.name}?`))
            _control.fetchDelete(item)
    }

    function renderLoading() {
        return (
            <div>
                <SpinnerComponent />
            </div>
        )
    }

    function renderMain() {
        let results = _results.get()
        let categories = results?.body?.data || []

        return (
            <div>
                <LayoutPage config={{ id: 'ManageDeals' }}>
                    <div className="manageDeals-header">
                        <PageTitleComponent value="Categories" />
                        <ButtonComponent events={{ handleClick: () => navigate('/create-category') }}>
                            + New Category
                        </ButtonComponent>
                    </div>

                    <div className="manageDeals-panel">
                        <div className={`manageCategories-listContainer ${_state.get('fetching') ? 'disabled' : ''}`}>
                            {categories.length ? (
                                <CategoryListComponent value={categories} events={{
                                    handleEdit: handleGoToEdit,
                                    handleDelete: handleDelete
                                }} />
                            ) : (
                                <div className="manageDeals-empty">No categories yet.</div>
                            )}
                        </div>
                    </div>
                </LayoutPage>
            </div>
        )
    }

    return _viewMain.get()
}

export { ManageCategoriesPage }
